<ng-container *ngIf="isLoading">
  <ng-container *ngTemplateOutlet="loader"></ng-container>
</ng-container>

<ng-container *ngIf="!isLoading && errors.length > 0">
  <div class="m-2 bg-red-500 text-white p-4 rounded">
    <h2 class="text-xl font-bold">Something went wrong:</h2>
    <ul>
      <li *ngFor="let error of errors">{{ error }}</li>
    </ul>
  </div>
</ng-container>

<!-- <ng-container *ngIf="!isLoading && errors.length === 0"> -->
  <div id="checkout"></div>
<!-- </ng-container> -->

<ng-template #loader>
  <div class="m-2">
    <div class="animate-pulse">
      <div class="h-4 bg-gray-300 rounded w-1/2 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-2/3 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-1/4 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-2/5 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-3/5 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-1/3 mb-2"></div>
      <div class="h-4 bg-gray-300 rounded w-1/6 mb-2"></div>
    </div>
  </div>
</ng-template>
